import { render, staticRenderFns } from "./BlogCard.vue?vue&type=template&id=621f16fc&scoped=true&lang=pug&"
import script from "./BlogCard.vue?vue&type=script&lang=js&"
export * from "./BlogCard.vue?vue&type=script&lang=js&"
import style0 from "./BlogCard.vue?vue&type=style&index=0&id=621f16fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621f16fc",
  null
  
)

export default component.exports